import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook } from '@fortawesome/pro-light-svg-icons/faAddressBook';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faUpload } from '@fortawesome/pro-light-svg-icons/faUpload';
import { faUserPlus } from '@fortawesome/pro-light-svg-icons/faUserPlus';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { addContactMessages } from './addContactMessages';
import { contactsMessages as messages } from './contactsMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ContactsEmptyProps {
  hasFilters: boolean;
  onClear: () => void;
  onImport: () => void;
  /** "Add contact": one person by hand. */
  onAdd: () => void;
}

/** No contacts (design outreach q4), or none for the filters ("Clear filters"). */
const ContactsEmptyComponent: React.FC<ContactsEmptyProps> = ({ hasFilters, onClear, onImport, onAdd }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  if (hasFilters) {
    return (
      <div className={styles.empty} data-testid="contacts-no-match">
        <h3 className={styles.h2}>{intl.formatMessage(messages.noMatch)}</h3>
        <SMLButton outline omitCap onClick={onClear}>
          {intl.formatMessage(messages.clearFilters)}
        </SMLButton>
      </div>
    );
  }
  return (
    <div className={styles.empty} data-testid="contacts-empty">
      <span className={styles.emptyIcon}>
        <FontAwesomeIcon icon={faAddressBook} />
      </span>
      <h3 className={styles.h2}>{intl.formatMessage(messages.emptyTitle)}</h3>
      <p className={styles.sub}>{intl.formatMessage(messages.emptyBody)}</p>
      <div className={styles.row}>
        <SMLButton
          color="primary"
          omitCap
          leftIcon={faMagnifyingGlass}
          onClick={() => router.push(SMLRoutes.outreachFind)}
        >
          {intl.formatMessage(messages.emptyFind)}
        </SMLButton>
        <SMLButton outline omitCap leftIcon={faUserPlus} onClick={onAdd}>
          {intl.formatMessage(addContactMessages.open)}
        </SMLButton>
        <SMLButton outline omitCap leftIcon={faUpload} onClick={onImport}>
          {intl.formatMessage(messages.importCsv)}
        </SMLButton>
      </div>
    </div>
  );
};

export const ContactsEmpty = TypedMemo(ContactsEmptyComponent);
